import { Controller } from "@hotwired/stimulus"

// Escucha el CustomEvent "menu-nav:edit" que dispara el dropdown
// cuando el usuario hace click en "Editar" una seccion o item del menu.
// El dropdown mueve sus items a <body>, por lo que el onclick normal
// no puede usar closest() para encontrar el modal. Este controller
// recibe el evento con el target_id y abre el modal correspondiente.

export default class extends Controller {
  connect() {
    this._handler = (e) => this._openEditModal(e)
    document.addEventListener("menu-nav:edit", this._handler)
  }

  disconnect() {
    document.removeEventListener("menu-nav:edit", this._handler)
  }

  _openEditModal(e) {
    const targetId = e.detail.target_id || e.detail.targetId
    // Buscar dentro de este controller (no document) para evitar
    // encontrar la instancia duplicada del drawer mobile oculto.
    const el = this.element.querySelector(`#${CSS.escape(targetId)}`)
    if (!el) return

    const modalEl = el.querySelector('[data-controller*="manage--modal"]')
    if (!modalEl) return

    const ctrl = this.application.getControllerForElementAndIdentifier(modalEl, "manage--modal")
    if (ctrl) ctrl.open()
  }
}
